<mat-card>
    <mat-card-header>
        <mat-card-title>General Enquiry</mat-card-title>
    </mat-card-header>
    <mat-card-content class="m-t-1">
          <div class="enquiryContainer">
                <div class="enquiryTypeContainer">
                    <label class="enquiryTypeLabel">I am seeking information about</label>
                    <mat-button-toggle-group class="enquiryTypeButtons"
                        name="enquiryType"
                        aria-label="Enquiry Type"
                        [hideSingleSelectionIndicator]="true"
                        [formControl]="generalEnquiryForm.controls.enquiryType"
                        >
                        
                        <mat-button-toggle value="visa">A Visa</mat-button-toggle>
                        <mat-button-toggle value="business">A Business Sponsorship</mat-button-toggle>
                        <mat-button-toggle value="other">Other</mat-button-toggle>
                    </mat-button-toggle-group>
                    @if(generalEnquiryForm.controls.enquiryType.invalid && submitAttempted){
                        <div class="error-message">Please select an enquiry type.</div>
                    }
                </div>
                
                <div class="enquiryTypeContentContainer">
                    @if(generalEnquiryForm.controls.enquiryType.value === 'other' || generalEnquiryForm.controls.enquiryType.value === 'visa') {
                     <app-applicant-details #applicantDetailsForm
                        [model]="model"
                        [formTypes]="formTypes"
                        [titles]="titles"
                        [countries]="countries"
                        [visaTypes]="visaTypes"
                        [maritalStatus]="maritalStatus"
                        [phoneTypes]="phoneTypes"
                        [enquiryType]="generalEnquiryForm.controls.enquiryType.value"
                        [isAddressForced]="isAddressForced"
                        
                        (formReady)="onChildFormReady($event)">
                    </app-applicant-details>

                        @if(generalEnquiryForm.controls.enquiryType.value === 'visa'){
                            <app-radio-input
                                label="Do you have a spouse/partner who is an Australian citizen, permanent resident or New Zealand citizen?"
                                [control]="generalEnquiryForm.controls.partnerCitizen" shortLabel="Partner Citizen"
                                [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
                                [errorMsg]="'Partner\'s citizenship is required'"
                                >
                            </app-radio-input>
                            <app-text-input
                                label="What is your usual occupation?" shortLabel="Occupation"
                                [control]="generalEnquiryForm.controls.occupation"
                                [errorMsg]="'Usual occupation is required'">
                                > 
                            </app-text-input>
                            <app-select-input 
                                [label]="'What is the highest level of education achieved by you?'" shortLabel="Education"
                                [control]="generalEnquiryForm.controls.education" [lookupItems]="educationLevels" placeholder="Select a Education Level">
                            </app-select-input>

                            <app-file-upload
                                [label]="'Please attach a copy of your resume here (if available) by clicking the button below'" shortLabel="Resume"
                                (change)="onFileUploaded($event)"
                                placeholder="Upload a file"
                                uploadType="resume"
                                [displayValue]="model.applicantDetails?.resumeFile?.[0]?.name || ''"
                            >
                            </app-file-upload>
                            <app-radio-input
                                label="Do you have a job offer from an Australian business or organisation?" shortLabel="Job Offer"
                                [control]="generalEnquiryForm.controls.hasJobOffer"
                                [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
                                [errorMsg]="'Have job offer is required'"
                                >
                            </app-radio-input>
                        }

                    }
                    @else if (generalEnquiryForm.controls.enquiryType.value === 'business') {
                        <app-business-enquiry-form #businessEnquiryForm
                            [model]="model"
                            [phoneTypes]="phoneTypes"
                            (formReady)="onChildFormReady($event)"
                        >
                        </app-business-enquiry-form>   
                    }

                    @if(generalEnquiryForm.controls.enquiryType.value != '') {

                        <app-feedback #feedbackForm
                            [model]="model"
                            [formTypes]="formTypes"
                            (formReady)="onChildFormReady($event)">
                        </app-feedback>
                        <app-data-protection  #dataProtectionForm
                            [model]="model"                        
                            (formReady)="onChildFormReady($event)">
                        </app-data-protection>
                    }
                </div>
        </div>
    </mat-card-content>
</mat-card>

